<script>
  import Link from '@components/Link.svelte';
  import Log from '@utils/log';
  import Viewport from '@components/Viewport.svelte';
  import { onMount } from 'svelte';
  import { page } from '$app/stores';

  let user = $page.error.user;
  const header = user && user.id ? 'This list has been deleted' : "Well that's embarrassing.";
  const message =
    user && user.id
      ? 'Sorry, it looks like the creator of this list has deleted it!'
      : "Sorry, we couldn't find the page you were looking for.";
  let logInfo = function () {
    let ref = document.referrer;

    if (ref && !ref.includes('/api/')) {
      Log.info(`[PAGE NOT FOUND] referrer: ${ref}, ip: [ip]`);
    }
  };

  onMount(() => {
    logInfo();
  });
</script>

<style>
  .pnf {
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 200px;
  }
</style>

<svelte:head>
  <title>404 - Page not found</title>
</svelte:head>

<a href="/">
  <img
    alt="logo"
    src="/images/logo-black.svg"
    style="width: 160px; height: 110px; position: absolute; left: 70px; top:
    30px; zoom: 0.5" />
</a>

<div class="pnf">
  <div style="text-align: center; margin-bottom: 100px">
    <img alt="logo" src="/images/404-monkey.png" />

    <div style="margin-top: 40px; font-size: 30px; font-weight: 500;">
      {header}
    </div>
    <div style="margin-top: 30px; margin-bottom: 60px;">{message}</div>

    <div>
      <Link href="/" text="Go to Homepage" style="font-weight: bold" />

      {#if user && user.id}
        <Viewport let:mobile>
          {#if mobile}
            <div style="margin-top: 20px;">
              <Link href={user.profile_path} text="See {user.name}'s other lists" style="font-weight: 400;" />
            </div>
          {:else}
            <Link
              href={user.profile_path}
              text="See {user.name}'s other lists"
              style="font-weight: 400; margin-left: 40px;" />
          {/if}
        </Viewport>
      {/if}
    </div>
  </div>
</div>
